// Version : 0.0.3
// Author : VISHNU
// LastEdit : Sabari
// Last ADD : Unwanted Redux Clear
// MODFIED DATE : 11-11-2025

const ChangeGroupOfficerActionTypes = {
	/*********************** GET CHANGE BRANCH OFFICER LIST START *********************/
	GET_CHANGE_BRANCH_OFFICER_LIST_START: 'get_change_branch_officer_start',
	GET_CHANGE_BRANCH_OFFICER_LIST_SUCCESS: 'get_change_branch_officer_success',
	GET_CHANGE_BRANCH_OFFICER_LIST_FAILURE: 'get_change_branch_officer_failure',
	GET_CHANGE_BRANCH_OFFICER_LIST_RESPONSE_RESET: 'get_change_branch_officer_response_reset',
	GET_CHANGE_BRANCH_OFFICER_LIST_RESPONSE_CHANGED: 'get_change_branch_officer_response_changed',
	/*********************** GET CHANGE BRANCH OFFICER LIST END *********************/

	/*********************** GET OFFICER CENTER LIST START *********************/
	GET_OFFICER_CENTER_LIST_START: 'get_officer_center_start',
	GET_OFFICER_CENTER_LIST_SUCCESS: 'get_officer_center_success',
	GET_OFFICER_CENTER_LIST_FAILURE: 'get_officer_center_failure',
	GET_OFFICER_CENTER_LIST_RESPONSE_RESET: 'get_officer_center_response_reset',
	GET_OFFICER_CENTER_LIST_RESPONSE_CHANGED: 'get_officer_center_response_changed',
	/*********************** GET OFFICER CENTER LIST END *********************/

	/*********************** GET LOAN GROUP LIST START *********************/
	GET_LOAN_GROUP_LIST_START: 'get_loan_group_start',
	GET_LOAN_GROUP_LIST_SUCCESS: 'get_loan_group_success',
	GET_LOAN_GROUP_LIST_FAILURE: 'get_loan_group_failure',
	GET_LOAN_GROUP_LIST_RESPONSE_RESET: 'get_loan_group_response_reset',
	GET_LOAN_GROUP_LIST_RESPONSE_CHANGED: 'get_loan_group_response_changed',
	/*********************** GET LOAN GROUP LIST END *********************/

	/*********************** UPDATE CHANGE GROUP OFFICER LIST START *********************/
	UPDATE_CHANGE_GROUP_OFFICER_LIST_START: 'update_change_group_officer_start',
	UPDATE_CHANGE_GROUP_OFFICER_LIST_SUCCESS: 'update_change_group_officer_success',
	UPDATE_CHANGE_GROUP_OFFICER_LIST_FAILURE: 'update_change_group_officer_failure',
	UPDATE_CHANGE_GROUP_OFFICER_LIST_RESPONSE_RESET: 'update_change_group_officer_response_reset',
	UPDATE_CHANGE_GROUP_OFFICER_LIST_RESPONSE_CHANGED:
		'update_change_group_officer_response_changed',
	/*********************** UPDATE CHANGE GROUP OFFICER LIST END *********************/
};

export default ChangeGroupOfficerActionTypes;
